var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4.85c-4.598 0-8.15 3.293-8.15 7.15 0 1.385.45 2.682 1.237 3.786a.85.85 0 0 1 .104.792l-.858 2.289 3.245-.65a.85.85 0 0 1 .533.067A9 9 0 0 0 12 19.15c4.598 0 8.15-3.292 8.15-7.15 0-3.857-3.552-7.15-8.15-7.15M2.15 12c0-4.979 4.507-8.85 9.85-8.85s9.85 3.871 9.85 8.85c0 4.98-4.507 8.85-9.85 8.85a10.7 10.7 0 0 1-4.36-.911l-4.473.895a.85.85 0 0 1-.963-1.132l1.241-3.31A8.14 8.14 0 0 1 2.15 12m5 0c0-.47.38-.85.85-.85h.01a.85.85 0 0 1 0 1.7H8a.85.85 0 0 1-.85-.85m4 0c0-.47.38-.85.85-.85h.01a.85.85 0 1 1 0 1.7H12a.85.85 0 0 1-.85-.85m4 0c0-.47.38-.85.85-.85h.01a.85.85 0 1 1 0 1.7H16a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgChat;